var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66235 7C3.40981 7 3.15727 6.90841 2.96449 6.72416L0.289177 4.16724C-0.0963923 3.79874 -0.0963923 3.2018 0.289177 2.83437C0.674746 2.46587 1.2982 2.46479 1.68377 2.83329L3.66235 4.72431L8.31623 0.27638C8.7018 -0.0921265 9.32525 -0.0921265 9.71082 0.27638C10.0964 0.644886 10.0964 1.24182 9.71082 1.61033L4.3602 6.72416C4.16742 6.90841 3.91488 7 3.66235 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c02437f1532b182092a027ff53e835f2.svg";
export { ForwardRef as ReactComponent };